import React from 'react';
import { product, solutionSteps } from '../data/landing';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
export function SolutionSection() {
  return <section className="bg-ivory py-12 md:py-24" data-id="element-201" data-mp="3o9tt42icso1k">
      <div className="mx-auto grid max-w-[1180px] grid-cols-1 items-center gap-12 px-5 md:grid-cols-2 md:gap-16 md:px-8" data-id="element-202" data-mp="3o77j7w7zpwg6">
        <div className="relative mx-auto h-[380px] w-full max-w-[340px] sm:h-[440px] sm:max-w-[420px] md:h-[520px]" data-id="element-203" data-mp="14kvkzeamli0">
          <img src={product.cover} alt="Identity & Faith, Volume 01 cover" className="absolute left-0 top-2 aspect-[9/16] w-[190px] -rotate-[4deg] sm:w-[220px] rounded-md object-cover shadow-[14px_18px_0_#E8E4D9,20px_30px_40px_rgba(20,33,61,0.22)] md:w-[260px]" data-id="element-204" data-mp="3t8wyjo28wwa2" />
          <img src={product.handout} alt="Student handout page from meeting YMR-02" className="absolute bottom-0 right-0 aspect-[9/16] w-[165px] rotate-[5deg] sm:w-[190px] rounded-md bg-white object-cover shadow-[0_16px_36px_rgba(20,33,61,0.2)] md:w-[220px]" data-id="element-205" data-mp="krsenaidsf2f" />
        </div>

        <div data-id="element-206" data-mp="3bai65g5hmfgv">
          <SectionHeading align="left" eyebrow="Meet the solution" title="Youth Ministry Ready™" highlight="Identity & Faith" data-id="element-207" data-mp="3b9yzivlafdi5" />
          <p className="text-ink md:text-lg" data-id="element-208" data-mp="3kadktuy94sln">
            Twelve Bible-based meetings for teenagers ages 12–18, with the preparation already mapped out—from the
            welcome to the weekly challenge.
          </p>
          <p className="mt-4 text-ink md:text-lg" data-id="element-209" data-mp="3u81fylzrs24c">
            Made for youth pastors, volunteer leaders, and small church youth teams. Use the scripts as written or make
            the language your own.
          </p>
          <ol className="mt-8 space-y-5" data-id="element-210" data-mp="6ufntq30imed">
            {solutionSteps.map((step, index) => <li key={step.title} className="flex gap-4" data-id="element-211" data-mp="bvmufltf5fjg" data-mpi={index}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy font-display text-xl font-extrabold text-amber" data-id="element-212" data-mp="gtocc3f3z8tc">
                  {index + 1}
                </span>
                <div data-id="element-213" data-mp="27y00ejgnbegx">
                  <h3 className="font-display text-[22px] font-bold uppercase leading-tight text-navy" data-id="element-214" data-mp="27yhupajqzim7">{step.title}</h3>
                  <p className="text-[15px] text-muted" data-id="element-215" data-mp="2mne9rrk81vwb">{step.body}</p>
                </div>
              </li>)}
          </ol>
          <CtaButton href="#offer-details" className="mt-10 w-full sm:w-auto" data-id="element-216" data-mp="2hu2zfgg7awzn">
            {product.ctaLabel}
          </CtaButton>
        </div>
      </div>
    </section>;
}